<template>
  <div class="channel-flow-container">
    <el-tabs v-model="activeComponent" class="tabs-container" tab-position="top" stretch>
      <el-tab-pane label="渠道流量导出-新版" name="ChannelFlowSourceImport">
        <keep-alive>
          <ChannelFlowSourceImport v-if="activeComponent === 'ChannelFlowSourceImport'" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="渠道流量导出-旧版" name="BetaHomeView">
        <keep-alive>
          <BetaHomeView v-if="activeComponent === 'BetaHomeView'" />
        </keep-alive>
      </el-tab-pane>
      <el-tab-pane label="当日渠道流量查询" name="TodayFlowSource">
        <keep-alive>
          <TodayFlowSource v-if="activeComponent === 'TodayFlowSource'" />
        </keep-alive>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script setup>
import { ref } from 'vue'
const activeName = ref('first')
import ChannelFlowSourceImport from '@/components/channel/ChannelFlowSourceImport.vue'
import BetaHomeView from '@/components/channel/BetaHomeView.vue'
import TodayFlowSource from '@/components/channel/TodayFlowSource.vue'

const activeComponent = ref('ChannelFlowSourceImport')

function switchComponent(component) {
  activeComponent.value = component
}
</script>

<style scoped>
.channel-flow-container {
  height: calc(100vh - 130px); /* 减去MenuNavigation高度 */
  padding: 0;
  margin: 0;
}

.tabs-container {
  display: flex;
  height: 100%;
}

</style>
